/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChamadoNovoAliases {
  AUTOCOMPLETE_TYPE = 'autocomplete-type',
  CARD_0 = 'card-0',
  ESTADO_CIVIL_MAPPER = 'estado-civil-mapper',
  FETCH_CALL_TYPES = 'fetch-call-types',
  FETCH_GUIDANCE = 'fetch-guidance',
  FETCH_TERM = 'fetch-term',
  FIELD_3 = 'field-3',
  FIELD_DS_DETAILING = 'field-dsDetailing',
  FIELD_DS_SUBJECT = 'field-dsSubject',
  FIELD_GUIDANCE = 'field-guidance',
  FIELD_REQUIRED_ATTACHMENT = 'field-required-attachment',
  FIELD_RESPONSABILITY_TERM = 'field-responsability-term',
  FIELD_TERM = 'field-term',
  FIELD_TERM_SEQUENCE = 'field-term-sequence',
  FIELD_UPLOADER = 'field-uploader',
  FILE_UPLOADER_0 = 'file-uploader-0',
  FORM_0 = 'form-0',
  FORM_NEW_CALL = 'form-new-call',
  HPMS_TERM_CHECKBOX = 'hpms-term-checkbox',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  INPUT_2 = 'input-2',
  MAPPER_0 = 'mapper-0',
  MODAL_RESPONSABILITY_TERM = 'modal-responsability-term',
  PANEL_0 = 'panel-0',
  PANEL_NEW_CALL = 'panel-new-call',
  PANEL_RESPONSABILITY_TERM = 'panel-responsability-term',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_AREA_1 = 'text-area-1',
  TEXT_GUIDANCE = 'text-guidance',
}
export { ChamadoNovoAliases };
